import { defer, Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { IsVarEmpty, isVarNotEmpty } from '../../utils/GlobalFunctions'
import { AkixiWindow, RxJSWindow } from '../Types/Types'

const winRef: AkixiWindow = window as AkixiWindow
const rxjs: Nullable<RxJSWindow> = winRef?.rxjs as Nullable<RxJSWindow>

if (!rxjs) {
    winRef.rxjs = {} as RxJSWindow
}

export const RxJS: RxJSWindow = winRef.rxjs as RxJSWindow
export const servletPath: string = (window as AkixiWindow).sSERVLETPATH ?? location.pathname

winRef.firstSubs = winRef.firstSubs ?? {}

export const tapOnce = <T extends unknown>(
    fn: () => Definable<Promise<unknown>>,
    name: string
): ((source$: Observable<T>) => Observable<T>) => {
    if (isVarNotEmpty(winRef?.firstSubs) && IsVarEmpty(winRef.firstSubs[name])) {
        winRef.firstSubs[name] = true
    }

    return (source$: Observable<T>): Observable<T> =>
        defer(
            (): Observable<T> =>
                source$.pipe(
                    tap((data: T): void => {
                        if (winRef?.firstSubs?.[name] && IsVarEmpty(data)) {
                            fn()

                            if (isVarNotEmpty(winRef?.firstSubs)) {
                                winRef.firstSubs[name] = false
                            }
                        }
                    })
                )
        )
}
